import { apiService } from './apiService';

export function getCurrenciesService(data) {
    return apiService({
        method: 'POST',
        url: '/currency/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByIdCurrenciesService(id) {
    return apiService({
        method: 'GET',
        url: '/currency/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function addCurrenciesService(data) {
    return apiService({
        method: 'POST',
        url: '/currency',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function updateCurrenciesService(id, data) {
    return apiService({
        method: 'PUT',
        url: '/currency/' + id,
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function deleteCurrenciesService(id) {
    return apiService({
        method: 'DELETE',
        url: '/currency/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
